import { type JSX } from "react";
import Webcam from "react-webcam";
import clsx from "clsx";

type AvatarCamProps = {
    className: string;
    rotate?: boolean;
}

const AvatarCam = ({ className, rotate = false }: AvatarCamProps): JSX.Element => {
    return (
        <div className={clsx("overflow-hidden aspect-3/4", className)}>
            <Webcam
                audio={false}
                className={clsx("w-full h-full object-cover scale-150", rotate ? "-rotate-90" : "")}
                mirrored={true}
            />
        </div>
    )
}

export default AvatarCam;
